import { render, staticRenderFns } from "./IconCarat.vue?vue&type=template&id=b8bc79a8&"
import script from "./IconCarat.vue?vue&type=script&lang=js&"
export * from "./IconCarat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports